
export const SuccessIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" stroke="#32DC62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1" strokeWidth="1.5"
      strokeLinecap="round" />
    <path d="M5.53125 8.62707L9.34481 12.6885L18.8024 3.28809" strokeWidth="1.5" strokeLinecap="round"
      strokeLinejoin="round" />
  </svg>
);
